var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingUse3 = function SvgLandingUse3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#landing-use-3_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.48,
    height: 47.48,
    x: 25.097,
    y: 35.201,
    fill: "url(#landing-use-3_svg__b)",
    rx: 23.74
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8F3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.713,
    d: "m40.697 58.82 5.876 5.876 11.75-11.751"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4586",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.07,
    d: "M23.98 82.726c-13.244-13.244-13.244-34.717 0-47.962 13.245-13.244 34.719-13.244 47.963 0s13.244 34.718 0 47.962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4687",
    d: "M48.158 18.922a7.461 7.461 0 1 0 0-14.922 7.461 7.461 0 0 0 0 14.922"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.418,
    height: 24.418,
    x: 63.759,
    y: 62.332,
    fill: "#F6F8FB",
    stroke: "#46407C",
    strokeWidth: 2.713,
    rx: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#423D75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.713,
    d: "m80.532 69.978-8.634 8.633M80.532 79.105l-8.634-8.633"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "landing-use-3_svg__b",
    x1: 64.386,
    x2: 51.778,
    y1: 24.769,
    y2: 79.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F55A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21213F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "landing-use-3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
};
export { SvgLandingUse3 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxyZWN0IHg9IjI1LjA5NjciIHk9IjM1LjIwMTIiIHdpZHRoPSI0Ny40OCIgaGVpZ2h0PSI0Ny40OCIgcng9IjIzLjc0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxwYXRoIGQ9Ik00MC42OTczIDU4LjgyMDNMNDYuNTcyNiA2NC42OTU3TDU4LjMyMzMgNTIuOTQ1IiBzdHJva2U9IiNFN0U4RjMiIHN0cm9rZS13aWR0aD0iMi43MTMxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMy45ODA4IDgyLjcyNjFDMTAuNzM2NSA2OS40ODE4IDEwLjczNjUgNDguMDA4NSAyMy45ODA4IDM0Ljc2NDFDMzcuMjI1MiAyMS41MTk4IDU4LjY5ODUgMjEuNTE5OCA3MS45NDI4IDM0Ljc2NDFDODUuMTg3MiA0OC4wMDg1IDg1LjE4NzIgNjkuNDgxOCA3MS45NDI4IDgyLjcyNjEiIHN0cm9rZT0iIzRDNDU4NiIgc3Ryb2tlLXdpZHRoPSI0LjA2OTcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQ4LjE1ODQgMTguOTIyM0M1Mi4yNzkxIDE4LjkyMjMgNTUuNjE5NSAxNS41ODE4IDU1LjYxOTUgMTEuNDYxMUM1NS42MTk1IDcuMzQwNDYgNTIuMjc5MSA0IDQ4LjE1ODQgNEM0NC4wMzc3IDQgNDAuNjk3MyA3LjM0MDQ2IDQwLjY5NzMgMTEuNDYxMUM0MC42OTczIDE1LjU4MTggNDQuMDM3NyAxOC45MjIzIDQ4LjE1ODQgMTguOTIyM1oiIGZpbGw9IiM0RDQ2ODciLz4KPHJlY3QgeD0iNjMuNzU4OSIgeT0iNjIuMzMyMiIgd2lkdGg9IjI0LjQxODMiIGhlaWdodD0iMjQuNDE4MyIgcng9IjEyLjIwOTEiIGZpbGw9IiNGNkY4RkIiIHN0cm9rZT0iIzQ2NDA3QyIgc3Ryb2tlLXdpZHRoPSIyLjcxMzE0Ii8+CjxwYXRoIGQ9Ik04MC41MzE2IDY5Ljk3ODJMNzEuODk4NCA3OC42MTEzIiBzdHJva2U9IiM0MjNENzUiIHN0cm9rZS13aWR0aD0iMi43MTMxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04MC41MzE2IDc5LjEwNDhMNzEuODk4NCA3MC40NzE3IiBzdHJva2U9IiM0MjNENzUiIHN0cm9rZS13aWR0aD0iMi43MTMxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjY0LjM4NTYiIHkxPSIyNC43Njg4IiB4Mj0iNTEuNzc3OSIgeTI9Ijc5LjMyMyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNUY1NUE1Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzIxMjEzRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";